import {Fragment, useEffect, useRef, useState} from 'react'
import {Dialog, Transition} from '@headlessui/react'

export default function SelectImagePopup({open, handleCancelAction, handleAcceptAction, allImages, emitSelectedImage, selected}) {
    const dialogRef = useRef(null);
    const closeAction = () => {
        handleCancelAction();
    }

    const setImage = (uid) => {
        emitSelectedImage(uid);
    }

    useEffect(() => {

        if (!selected && allImages.length > 0) {
            const firstImage = allImages[0];
            emitSelectedImage(firstImage.uid);
        }

        if (open && dialogRef.current) {
            dialogRef.current.focus();
        }
    }, [open]);

    const handleKeyDown = (e) => {
        if (!open) return;
        const currentIndex = allImages.findIndex(image => image.uid === selected);
        switch (e.key) {
            case 'ArrowRight':
            case 'ArrowDown':
                e.preventDefault();
                const nextIndex = (currentIndex + 1) % allImages.length;
                emitSelectedImage(allImages[nextIndex].uid);
                break;
            case 'ArrowLeft':
            case 'ArrowUp':
                e.preventDefault();
                const prevIndex = (currentIndex - 1 + allImages.length) % allImages.length;
                emitSelectedImage(allImages[prevIndex].uid);
                break;
            case 'Enter':
                e.preventDefault();
                handleAcceptAction();
        }
    }

    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={closeAction}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"/>
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel
                                className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">

                                <div>
                                    <h2 className="text-sm lg:text-lg">
                                        Kies een afbeelding voor op de offerte.
                                        <div
                                            className="absolute top-4 right-[4%] w-6 h-6 cursor-pointer"
                                            onClick={() => closeAction()}
                                        >
                                            <div
                                                className="absolute w-full h-[3px] bg-olaf-green-500 top-1/2 transform -translate-y-1/2 rotate-45 rounded-[1px]"></div>
                                            <div
                                                className="absolute w-full h-[3px] bg-olaf-green-500 top-1/2 transform -translate-y-1/2 -rotate-45 rounded-[1px]"></div>
                                        </div>
                                    </h2>
                                        <div
                                            ref={dialogRef}
                                            onKeyDown={handleKeyDown}
                                            tabIndex={0} // This makes the div focusable
                                            className="grid grid-cols-3 gap-2 h-80 mt-4 overflow-y-scroll outline-0">
                                            {allImages.map((image, i) => (
                                                <img
                                                    src={image.img}
                                                    key={i}
                                                    onClick={() => setImage(image.uid)}
                                                    className={`cursor-pointer aspect-square object-cover ${
                                                        selected === image.uid &&
                                                        "border-4 border-olaf-orange-500 cursor-default"
                                                    }`}
                                                />
                                            ))}
                                        </div>
                                    <button
                                        onClick={() => handleAcceptAction()}
                                        className="cursor-pointer w-full h-[40px] flex items-center rounded-tl-[10px] rounded-br-[10px] text-sm font-bold border-2 bg-olaf-green-500 text-white border-olaf-green-500 justify-center"
                                    >
                                        Toevoegen
                                    </button>
                                </div>

                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}